import React from "react";

import { useFormatMessageMap } from "src/common/hooks/useFormatMessageMap";
import { fsnMessages } from "src/messages/fsn";

export function useFormatFsn(): (tag: {
	vocab: string;
	code: string;
}) => string {
	const formatMessage = useFormatMessageMap();
	return React.useCallback(
		({ vocab, code }) => formatMessage(fsnMessages, `${vocab}|${code}`),
		[formatMessage]
	);
}
